import { Image } from '../../components/core/image/Image'
import { Section } from '../../components/core/section/Section'
import { Text } from '../../components/core/text/Text'
import { VimeoPlayer } from '../../components/core/vimeoPlayer/VimeoPlayer'
import s from '../../styles/pages/Podcast.module.scss'
import c from 'classnames'
import { useEffect, useState } from 'react'
import { useRouter } from 'next/router'
import ShareModal from '../../components/components/share/Share'
import { Button } from '../../components/core/button/Button'
import Meta from '../../components/meta/Meta'
import episodes from '../../episodes'
import helperFunctions from '../../utils/helperFunctions'
import ServiceCard from '../../slices/ServiceCard'
import { RandomArticles } from '../../components/components/randomArticles'
import { Container } from '../../components/core/container/Container'
import { RecentlyDeceacedModule } from '../../components/components/recentlyDeceacedModule/RecentlyDeceacedModule'

export default function Podcast() {
    const router = useRouter()

    const [episode, setEpisode] = useState(episodes[0])
    const [epIndex, setEpIndex] = useState(0)
    const [openModal, setOpenModal] = useState(false)
    const [isTablet, setIsTablet] = useState(false)
    const [firstRender, setFirstRender] = useState(true)

    useEffect(() => {
        const { vidId } = router.query
        const episode = episodes.find(
            (e) => e.videoId === parseInt(vidId as string)
        )
        vidId && setEpisode(episode)
    }, [])

    useEffect(() => {
        function changeBtnText() {
            if (window.innerWidth < 720 && !isTablet) {
                setIsTablet(true)
            } else if (window.innerWidth >= 720 && isTablet) {
                setIsTablet(false)
            }
        }
        window.addEventListener('resize', changeBtnText)
        if (firstRender) {
            changeBtnText()
            setFirstRender(false)
        }
        return () => window.removeEventListener('resize', changeBtnText)
    }, [isTablet])

    return (
        <>
            <Meta
                title="Minningar - Hlaðvarp"
                seoTitle="Minningar - Hlaðvarp"
                description=""
                type="website"
                url=""
                image={episode.thumbnail}
            />
            <Section>
                <Container>
                    <div className={s.header}>
                        <Text variant="h1" className={s.header__title}>
                            Hlaðvarp
                        </Text>
                        <Text variant="p-18">
                            Hlaðvarp Minningar.is er í umsjón Sirrýjar
                            Arnardóttur, þar sem hún tekur fólk tali um
                            fráfallna þjóðþekkta einstaklinga og rifjar upp
                            lifandi minningar frá ævi þeirra og störfum.
                        </Text>
                    </div>
                </Container>
                <Container className={s.podcast}>
                    {/* video */}
                    <VimeoPlayer
                        className={s.video}
                        vimeoId={episode.videoId}
                        imgSrc={episode.thumbnail}
                    />
                    {/* playlist */}
                    <div className={s.playlist}>
                        {episodes.map((ep, index) => (
                            <Item
                                key={index}
                                vidFunc={() => {
                                    setEpisode(ep)
                                    setEpIndex(index)
                                }}
                                selected={episode.videoId === ep.videoId}
                                title={`Þáttur ${index + 1} | ${ep.length}`}
                                description={ep.title}
                                imgSrc={ep.playlistImage}
                            />
                        ))}
                    </div>
                    {/* description */}
                    <div className={s.desc}>
                        <div className={s.desc__info}>
                            <div className={s.desc__info__episode}>
                                <Text
                                    className={s.desc__info__episode__text}
                                    variant="p-small"
                                >
                                    {`Þáttur ${epIndex + 1}`}&nbsp; | &nbsp;
                                    {episode.length}
                                </Text>
                                <Text variant="p-small">
                                    {helperFunctions.getDate(
                                        new Date(episode.date)
                                    )}
                                </Text>
                            </div>
                            <Text variant="h3">{episode.title}</Text>
                            {episode.description}
                            {/* buttons */}
                        </div>

                        <div className={s.desc__buttons}>
                            <Button
                                className={s.desc__buttons__share}
                                variant="arrow"
                                icon="share"
                                mirror
                                onClick={() => setOpenModal(true)}
                            >
                                Deila
                            </Button>
                            <div className={s.desc__buttons__links}>
                                <Button
                                    variant="iconL"
                                    icon="spotify"
                                    to={episode.spotify}
                                >
                                    {!isTablet && 'Hlusta á Spotify'}
                                </Button>
                                <Button
                                    variant="iconL"
                                    icon="youtube"
                                    to={episode.youtube}
                                >
                                    {!isTablet && 'Horfa á Youtube'}
                                </Button>
                                <Button
                                    variant="iconL"
                                    icon="google"
                                    to={episode.google}
                                >
                                    {!isTablet && 'Hlusta á Google Hlaðvarpi'}
                                </Button>
                            </div>
                        </div>
                    </div>
                </Container>
            </Section>

            <RandomArticles showPodcast={false} />

            <ServiceCard
                slice={{
                    primary: {
                        title: 'Viltu skrifa minningargrein?',
                        description:
                            'Það er einfalt og gjaldfrjálst að skrifa minningargrein á Minningar.is sem birtist á minningarsíðu viðkomandi.',
                        buttonLink: '/memories',
                        buttonText: 'Skrifa minningargrein',
                    },
                }}
            />
            <Section>
                <RecentlyDeceacedModule />
            </Section>
            <ShareModal
                setOpenModal={setOpenModal}
                url={'minningar.is/podcast/' + episode.videoId}
                isOpen={openModal}
            />
        </>
    )
}

function Item({ title, description, imgSrc, selected = false, vidFunc }) {
    return (
        <div
            className={c(s.item, selected && s.selItem)}
            onClick={() => vidFunc()}
        >
            <Image className={s.image} src={imgSrc} />
            <div className={s.text}>
                <Text variant="h6">{title}</Text>
                <Text variant="p">{description}</Text>
            </div>
        </div>
    )
}
